import { render, staticRenderFns } from "./Register.vue?vue&type=template&id=6dbf1cd8&scoped=true&"
import script from "./Register.vue?vue&type=script&lang=js&"
export * from "./Register.vue?vue&type=script&lang=js&"
import style1 from "./Register.vue?vue&type=style&index=1&id=6dbf1cd8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dbf1cd8",
  null
  
)

export default component.exports